module.exports = __webpack_public_path__ + "static/media/unit 3-19.b83e17ab.jpg";